export default [
  {
    path: '/admin/product-add-on',
    name: 'product-add-on',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/add-on')
  },
  {
    path: '/admin/product-add-on/:id/create',
    name: 'product-add-on-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/add-on/create.vue')
  },
]